export const agendaData = [
  {
    date: "Tuesday, 03 March 2026",
    entries: [
      {
        time: "15:00 – 18:00",
        title: "Onsite Registration",
        description: "Pick up conference badge and materials near hotel lobby",
        venue: "-",
      },
      {
        time: "15:00 – 18:00",
        title: "The FIBS Playoff",
        description:
          "Kick off the excitment with a friendly tournament-style showdown where delegates can compete, cheer, and connect before the evening’s welcome cocktail.",
        venue: "Smart Casual | Venue to be advised",
      },
      {
        time: "19:00 – 21:30",
        title: "FIBS Welcome Cheers @ Joyride",
        description: "",
        venue:
          "Smart Casual | Venue: Joyride Diner - Studio City Macau, Level 1",
      },
    ],
  },
  {
    date: "Wednesday, 04 March 2026",
    entries: [
      {
        time: "09:00 – 09:15",
        title: "Opening Remarks by Fredrik Nyberg",
        description: "",
        venue: "Smart Casual | Venue: Ballroom",
      },
      {
        time: "09:15 – 10:00",
        title: "Speech / Panel Discussion",
        description: "",
        venue: "Smart Casual | Venue: Ballroom",
      },
      {
        time: "10:00 – 10:15",
        title: "Coffee Break",
        description: "",
        venue: "-",
      },
      {
        time: "10:15 – 11:00",
        title: "Speech / Panel Discussion",
        description: "",
        venue: "Smart Casual | Venue: Ballroom",
      },
      {
        time: "11:00 – 11:45",
        title: "Group Photo",
        description: "",
        venue: "-",
      },
      {
        time: "11:45 – 13:20",
        title: "Lunch",
        description: "",
        venue: "-",
      },
      {
        time: "13:20 – 17:00",
        title: "Face-to-Face Meetings",
        description: "",
        venue: "-",
      },
      {
        time: "18:15",
        title: "Meet at hotel lobby for transport to dinner",
        description: "",
        venue: "Smart Casual | Venue: Hotel lobby",
      },
      {
        time: "19:00 - 22:00",
        title: "FIBS Taste at Rocks Hotel Macau",
        description:
          "A boutique seaside escape, Rocks Hotel Macau combines timeless charmand waterfront views at Fisherman’s Wharf.",
        venue: "Smart Casual | Venue: Rocks Hotel Macau",
      },
    ],
  },
  {
    date: "Thursday, 05 March 2026",
    entries: [
      {
        time: "10:00 – 10:45",
        title: "Face-to-Face Meetings",
        description: "",
        venue: "Smart Casual | Venue: Ballroom",
      },
      {
        time: "10:45 – 11:00",
        title: "Coffee Break",
        description: "",
        venue: "Smart Casual | Venue: Ballroom",
      },
      {
        time: "11:00 – 12:45",
        title: "Face-to-Face Meetings",
        description: "",
        venue: "Smart Casual | Venue: Ballroom",
      },
      {
        time: "12:40 – 14:00",
        title: "Lunch",
        description: "",
        venue: "",
      },
      {
        time: "14:00 – 18:00",
        title: "FIBS Macau City Explorer with Grand Prix Museum",
        description:
          "Uncover Macau’s unique blend of tradition and modernity, topped off with a fascinating tour of the iconic Macau Grand Prix Museum.",
        venue: "FIBS polo t-shirt | Venue: Meet at hotel lobby",
      },
      {
        time: "18:00 onwards",
        title: "Free & Easy",
        description: "",
        venue: "",
      },
      {
        time: "22:00 – 00:00",
        title: "The FIBS Eclipse @ MOP",
        description:
          "Join us for an unforgettable night of music, dancing, and celebration at Moon on Planet.",
        venue: "Smart Casual / Club Chic | Venue: Meet at hotel lobby",
      },
    ],
  },
  {
    date: "Friday, 06 March 2026",
    entries: [
      {
        time: "10:00 – 12:40",
        title: "Face-to-Face Meetings",
        description: "",
        venue: "Smart Casual | Venue: Ballroom",
      },
      {
        time: "12:40 – 14:00",
        title: "Lunch",
        description: "",
        venue: "",
      },
      {
        time: "14:00 – 15:20",
        title: "Face-to-Face Meetings",
        description: "",
        venue: "Smart Casual | Venue: Ballroom",
      },
      {
        time: "15:20 – onwards",
        title: "The Finale – Chill & Cheers",
        description:
          "Wrap up the conference with a relaxed hour of drinks and good company until we meet again.",
        venue: "Venue : Ballroom",
      },
    ],
  },
];
